var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ModalClose",on:{"click":function($event){return _vm.$emit('close')},"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"]))return null;return _vm.$emit('close')}}},[_c('Icon',{attrs:{"name":"cross"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }